import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { ConfigureScanMenuComponent } from '../../shared/components/configure-scan-menu/configure-scan-menu.component';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { startRegistration } from '@simplewebauthn/browser';
import {
  getTimeZoneValuesWithDiff,
  getTimezoneInfo,
  isLargeScreen,
} from '../../../global.variable';
import { AppService } from '../../app.service';
import { PagesService } from '../../pages/pages/pages.service';

import { ChangePasswordComponent } from '../../shared/components/change-password/change-password.component';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { FileUploadComponent } from '../../shared/components/file-upload/file-upload.component';
import { ImageCaptureComponent } from '../../shared/components/image-capture/image-capture.component';
import { ModalDialogueService } from '../../shared/components/modal-dialogue/modal-dialogue.service';
import { DataCheckService } from '../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../shared/services/loading-spinner.service';
import { ToasterService } from '../../shared/services/toaster.service';
import { UserProfileService } from './user-profile.service';

@Component({
  selector: 'gtapp-user-profile',
  standalone: false,
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss',
})
export class UserProfileComponent implements OnInit, OnDestroy {
  userDetails: any;
  dialogref: any;
  userData: any;
  profileForm: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl(''),
    first_name: new UntypedFormControl(''),
    last_name: new UntypedFormControl(''),
    mobile_number: new UntypedFormControl(''),
    time_zone: new UntypedFormControl(''),
  });
  emailUpdateForm: UntypedFormGroup = new UntypedFormGroup({
    new_email: new UntypedFormControl('', [
      Validators.required,
      Validators.email,
    ]),
    v_code: new UntypedFormControl(''),
  });
  message: string = '';

  userProfileUrl: any;

  actualUploadFile: any;
  fileData: any = [];

  userLicenses: any = [];

  userGroups: any;
  currentTheme: any;

  isTrustedDevice: boolean = false;
  stateTimeZones: any;
  selectedTimeZone: any;
  muteNotification: number = 30;
  largeView: Boolean = isLargeScreen;

  emailUpdateStepper: number = 1;
  newEmailAddress: string = '';
  isDispatchUser = this.dataCheckService.isDispatchUser();
  isAdmin = this.dataCheckService.isUserAdmin();

  userDevicesListData: any = [];

  emailAlertNotificationConfig: any = {};

  emailNotificationListData: any = [];
  allEmailAlertsOn: boolean = false;

  hasMultipleAccountsLinked: boolean = true;

  constructor(
    private spinnerService: LoadingSpinnerService,
    private appService: AppService,
    private profileService: UserProfileService,
    private dialogService: ModalDialogueService,
    private pageService: PagesService,
    private router: Router,
    private viewContainerRef: ViewContainerRef,
    private dataCheckService: DataCheckService,
    private toasterService: ToasterService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.userData = this.appService.getUserData();
    this.checkMultipleAccountsLinked();

    this.getUserDevicesList();

    this.muteNotification = this.toasterService.getNotificationVolume();

    this.isTrustedDevice = this.dataCheckService.isTrustedDevice();

    this.spinnerService.show();
    this.getProfileData();
    this.getStates();
    if (this.isDispatchUser || this.isAdmin) {
      this.emailNotificationListData = [
        {
          key: 'stop_incident_review_notification',
          label: 'Incident Report Pending Review',
          // true: 'You will no longer receive incident logged mail summary',
          // false: 'You will receive incident logged mail summary',
        },
        {
          key: 'stop_long_eta_notification',
          label: 'Long In Transit ETA Provided',
          // true: 'You will no longer email alert when user enters long ETA',
          false:
            'If a guard provides enters an ETA > 80 minutes during the day and > 40 minutes during the night.',
        },
        {
          key: 'stop_missed_eta_notification',
          label: `In Transit ETA Missed`,
          // true: 'You will no longer receive job completed mail summary',
          // false: 'You will  longer receive job completed mail summary',
        },
        {
          key: 'stop_declined_job_notification',
          label: `Shift Declined`,
          // true: 'You will no longer receive job completed mail summary',
          // false: 'You will  longer receive job completed mail summary',
        },
        {
          key: 'stop_sos_alert_notification',
          label: `SOS Alerts`,
          // true: 'You will no longer receive job completed mail summary',
          // false: 'You will  longer receive job completed mail summary',
        },
        {
          key: 'stop_missed_welfare_notification',
          label: `Missed Welfare Checks`,
          // true: 'You will no longer receive job completed mail summary',
          // false: 'You will  longer receive job completed mail summary',
        },
        {
          key: 'stop_stale_response_job_notification',
          label: `Alarm Response No Activity`,
          // true: 'You will no longer receive job completed mail summary',
          // false: 'You will  longer receive job completed mail summary',
        },
        {
          key: 'stop_late_to_shift_notification',
          label: `Late to Shift / Clock-In`,
          // true: 'You will no longer receive job completed mail summary',
          // false: 'You will  longer receive job completed mail summary',
        },
      ];
    }
    if (this.isAdmin) {
      this.emailNotificationListData = [
        {
          key: 'stop_managers_report_notification',
          label: `Daily Manager's Report`,
          // true: 'You will no longer receive job completed mail summary',
          // false: `The manager's report shows you information such as `,
        },
        {
          key: 'stop_weekly_stats_notification',
          label: `Weekly Stats Report`,
          // true: 'You will no longer receive job completed mail summary',
          // false: 'You will  longer receive job completed mail summary',
        },
        {
          key: 'stop_missed_checkpoint_scan_notification',
          label: `Missed Checkpoint Scans`,
          // true: 'You will no longer receive job completed mail summary',
          // false: 'You will  longer receive job completed mail summary',
        },
        {
          key: 'stop_deleted_job_notification',
          label: `Job Deleted`,
          // true: 'You will no longer receive job completed mail summary',
          // false: 'You will  longer receive job completed mail summary',
        },

        ...this.emailNotificationListData,
      ];
    }
  }
  ngOnDestroy(): void {}
  checkMultipleAccountsLinked() {
    this.profileService
      .getUserConfig({
        has_other_associated_accounts: 1,
      })
      .subscribe((resp: any) => {
        this.hasMultipleAccountsLinked = Boolean(
          resp?.has_other_associated_accounts ||
          (
            JSON.parse(
              localStorage.getItem(btoa('userLinkedAccountTokens')) || '[]',
            ) || []
          )?.length > 1,
        );
      });
  }

  getStates() {
    this.appService.getStates(1).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.stateTimeZones = getTimeZoneValuesWithDiff(
          response?.time_zone_list,
        );
      }
    });
  }

  getProfileData() {
    this.spinnerService.show();
    this.profileService.fetchUserProfile('api').subscribe((res) => {
      if (res['status'] === 'success') {
        this.formatProfileData(res['data']);

        this.spinnerService.hide();
      }
    });
  }
  formatProfileData(data: any) {
    this.userDetails = data;

    this.emailAlertNotificationConfig =
      this.userDetails?.preferences?.email_alert_config || {};

    this.selectedTimeZone = data?.time_zone;
    if (data?.time_zone) {
      this.userDetails.timeZone = getTimezoneInfo(data?.time_zone);
    }

    this.userGroups = [
      ...this.userDetails?.user_group?.map((item: any) => {
        return item?.name;
      }),
    ];

    this.profileForm.reset(this.userDetails);
    this.profileForm.controls['time_zone'].setValue(data?.time_zone);
    this.userLicenses = data?.license;

    this.profileForm.get('email')?.disable();

    this.userProfileUrl = this.userDetails?.profile_image;

    this.pageService.miscSubjectParam.next({ updateProfileDetail: true });
  }

  editProfile(template: TemplateRef<any>) {
    const dialogref = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
    dialogref.afterClosed().subscribe((value) => {});
  }

  openPasswordForm() {
    const dialogRefCP = this.dialogService.open(ChangePasswordComponent, {
      data: '',
    });
    dialogRefCP.afterClosed().subscribe((value) => {});
  }

  onSubmitClicked(passwordForm: any) {
    if (passwordForm) {
      this.profileService.changePassword(passwordForm).subscribe((response) => {
        if (response['status'] == 'success') {
          this.toasterService.setMessage({
            successMessage: response['message'],
            errorMessage: '',
          });
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
    }
  }

  updateProfileDetails() {
    if (!this.profileForm.valid) return;
    this.profileForm.get('email')?.enable();
    let requestData = { data: this.profileForm.value };
    requestData['data']['time_zone'] = this.selectedTimeZone;
    if (!this.profileForm.value?.mobile_number) {
      this.profileForm.controls['mobile_number'].setValue(null);
    }
    this.profileService
      .updateProfileDetails(requestData)
      .then((response: any) => {
        if (response['status'] == 'success') {
          let userData = this.appService.getUserData();
          userData.profile = response['data'];
          this.appService.setUserData(userData);
          // window.location.reload();
          this.toasterService.setMessage({
            successMessage: response['message'],
            errorMessage: '',
          });

          this.formatProfileData(response['data']);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }

  sendVerificationCode() {
    this.spinnerService.show();

    this.profileService
      .updateEmail(
        {
          ...this.emailUpdateForm.value,
          override:
            this.newEmailAddress !== this.emailUpdateForm.value?.new_email,
        },
        { send_otp: 1 },
      )
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.spinnerService.hide();
          this.emailUpdateStepper = 2;
          this.newEmailAddress = this.emailUpdateForm.value?.new_email;

          this.emailUpdateForm.controls['v_code'].setValidators([
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(6),
          ]);
          this.emailUpdateForm.controls['v_code'].setValue('');
          this.emailUpdateForm.controls['v_code'].updateValueAndValidity();
          this.toasterService.setMessage({
            successMessage: response['message'],
            errorMessage: '',
          });
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  updateEmailAddress() {
    this.spinnerService.show();

    this.profileService
      .updateEmail(this.emailUpdateForm.value, { verify_otp: 1 })
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: response['message'],
            errorMessage: '',
          });
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  checkEmailEnter(template: any) {
    this.emailUpdateStepper = 1;
    this.emailUpdateForm.controls['v_code'].removeValidators([
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(6),
    ]);
    this.emailUpdateForm.controls['v_code'].updateValueAndValidity();
    this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  openCamPopup() {
    if (this.largeView) {
      this.dialogref = this.dialogService.open(FileUploadComponent, {
        data: { showFrom: 'userProfilePage' },
      });
      this.dialogref.afterClosed().subscribe((value: any) => {
        if (value && value !== 'error') {
          this.actualUploadFile = value.actualFileUpload;
          this.onFileSubmit();
        }
      });
    } else {
      const dailogRef = this.dialogService.open(ImageCaptureComponent);
      dailogRef.afterClosed().subscribe((res: any) => {
        if (res && res !== 1) {
          this.actualUploadFile = res;
          this.onFileSubmit();
        }
      });
    }
  }
  openTemplate(template: any) {
    this.dialogService.open(template, {}, this.viewContainerRef);
  }

  onFileSubmit(responseId?: any) {
    this.spinnerService.show();
    let fileData: FormData = new FormData();
    fileData.append('file', this.actualUploadFile);
    if (responseId) fileData.append('response_id', responseId);

    this.appService
      .formDataApi(
        `profile/update_profile_image`,
        fileData,
        false,
        {},
        'POST',
        false,
      )
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successTick: true,
          });
          setTimeout(() => {
            window.location.reload();
          }, 1800);
        } else {
          this.spinnerService.hide();
          if (response?.response_id) {
            const dialogRef = this.dialogService.open(ImageCaptureComponent, {
              data: { templateName: 'faceComparisonFaledTemplate' },
            });
            dialogRef.afterClosed().subscribe((res: any) => {
              if (res) {
                this.openCamPopup();
              } else {
                this.onFileSubmit(response?.response_id);
              }
            });
          } else {
            this.actualUploadFile = null;
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response?.message,
              failureCross: true,
              timeOut: 5000,
            });
          }
        }
      });
  }
  removeImage() {
    let dialogMsg = `Are you sure to remove the profile picture?`;
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Remove Picture',
        message: dialogMsg,
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value === true) {
        let params = { remove_profile_image: 1 };
        this.spinnerService.show();
        this.profileService
          .removeProfileImage(params)
          .subscribe((response: any) => {
            if (response['status'] == 'success') {
              window.location.reload();
            } else {
              this.toasterService.setMessage({
                errorMessage: response['message'],
                successMessage: '',
              });
            }
            this.spinnerService.hide();
          });
      }
    });
  }

  async fidoStartRegistration(responseBody: any) {
    try {
      let regResp = await startRegistration({
        optionsJSON: JSON.parse(responseBody),
      });
      if (regResp) {
        this.profileService
          .fidoRegister(regResp, { verify: 1 })
          .then((response: any) => {
            if (response['status'] == 'success') {
              window.location.reload();
            } else {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
          });
      }
    } catch (err: any) {
      if (err?.message === 'The authenticator was previously registered') {
        localStorage.setItem(btoa('fidoConfiguredInDevice'), 'true');
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: 'The authenticator was previously registered',
        });

        window.location.reload();
      }
    }
  }

  fidoRegister() {
    this.profileService.fidoRegister().then((response: any) => {
      if (response['status'] == 'success') {
        this.fidoStartRegistration(response['data']);
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
      }
    });
  }

  mobileNumberCheck() {
    if (!this.profileForm.value?.mobile_number) {
      this.profileForm.controls['mobile_number'].setValue(null);
      this.profileForm.controls['mobile_number'].removeValidators([
        Validators.minLength(7),
        Validators.maxLength(10),
        //Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
        Validators.pattern('^(\\+?(61|64|675)|0)?[0-9]{7,10}$'),
      ]);
    } else {
      this.profileForm.controls['mobile_number'].setValidators([
        Validators.minLength(7),
        Validators.maxLength(10),
        //Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
        Validators.pattern('^(\\+?(61|64|675)|0)?[0-9]{7,10}$'),
      ]);
    }
  }

  changeNotificationVolume() {
    this.spinnerService.show();
    this.profileService
      .updateUser(
        {
          data: {
            mute_notification: this.muteNotification,
          },
        },
        { save_preference: 1 },
        false,
      )
      .then((response: any) => {
        if (response?.status === 'success') {
          let userData = this.appService.getUserData();
          if (userData?.preferences) {
            userData.preferences.mute_notification = this.muteNotification;
            this.appService.setUserData(userData);
          }
          this.toasterService.setMessage({
            successMessage: 'Volume Updated',
            errorMessage: '',
          });
          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  onTimeZoneChange(event: any) {
    this.selectedTimeZone = event?.target.value;
  }

  changeJobAlertStatus() {
    this.isDispatchUser = false;
    this.isAdmin = false;
    const currentValue = this.userDetails?.job_notification;

    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: currentValue
          ? 'Turn off notifications'
          : 'Turn on notifications',
        message: currentValue
          ? 'You will no longer receive job completed mail summary'
          : 'Start recieving job summary in mail whenever a job is completed',
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value === true) {
        this.spinnerService.show();
        this.profileService
          .updateUser({}, { update_job_notification_preference: 1 }, false)
          .then((response: any) => {
            if (response?.status === 'success') {
              this.formatProfileData(response['data']);
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: response['message'],
                errorMessage: '',
              });
            } else {
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
          });
      } else {
        this.userDetails.job_notification = currentValue;
      }
      this.isDispatchUser = this.dataCheckService.isDispatchUser();
      this.isAdmin = this.dataCheckService.isUserAdmin();
    });
  }
  getUserDevicesList() {
    this.spinnerService.show();
    this.profileService.getUserDevices().subscribe((response: any) => {
      if (response?.status === 'success') {
        this.spinnerService.hide();
        this.userDevicesListData = response?.data;
      } else {
        this.spinnerService.hide();
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
      }
    });
  }
  deleteUserDevice(deviceData: any, deviceType: string) {
    let body: any = { id_list: [deviceData?.id] };
    let params: any = {};
    if (deviceType === 'push') {
      params.push_devices = 1;
    }
    this.spinnerService.show();
    this.profileService
      .manageUserDevices(body, params)
      .subscribe((response: any) => {
        if (response?.status === 'success') {
          this.spinnerService.hide();

          this.getUserDevicesList();
          this.toasterService.setMessage({
            successMessage: response['message'],
            errorMessage: '',
          });
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }

  updateEmailAlertNotificationSetting() {
    this.spinnerService.show();
    this.profileService
      .updateUser(
        {
          job_notification: this.userDetails?.job_notification,
          email_alert_config: this.emailAlertNotificationConfig,
        },
        { update_email_alerts: 1 },
        false,
      )
      .then((response: any) => {
        if (response?.status === 'success') {
          this.formatProfileData(response['data']);
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: response['message'],
            errorMessage: '',
          });
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  checkAllAlertsSelected() {
    const listItemsEnabled = this.emailNotificationListData?.filter(
      (nAlert: any) => !this.emailAlertNotificationConfig[nAlert?.key],
    );

    this.allEmailAlertsOn =
      this.userDetails?.job_notification &&
      listItemsEnabled?.length === this.emailNotificationListData?.length;
  }
  selectAllAlerts(event: any) {
    const checked = event.target.checked;
    this.userDetails.job_notification = checked;
    this.emailNotificationListData?.forEach((nAlert: any) => {
      this.emailAlertNotificationConfig[nAlert?.key] = !checked;
    });
    this.checkAllAlertsSelected();
  }
  openSelectAccountTemplate() {
    this.pageService.miscSubjectParam.next({ openSelectAccount: true });
  }
  configureCheckpointScanMenu() {
    const dialogRef = this.dialogService.open(ConfigureScanMenuComponent);
  }
}
